import { Run } from "types/generated";

export type RunsListPerCommit = Array<{
  hash: string;
  group: Run[];
  selectable: boolean;
  index: number;
}>;

export const getGroupKey = (hash: string, index: number): string => {
  return `${hash}_${index}`;
};

export const getSelectableRunIds = (
  runsListPerCommit: RunsListPerCommit,
  filter?: (run: Run) => boolean
): Set<string> => {
  const selectedIds = new Set<string>();

  for (const { selectable, group } of runsListPerCommit) {
    if (!selectable) continue;

    for (const run of group) {
      if (!filter || filter(run)) {
        selectedIds.add(run.id);
      }
    }
  }

  return selectedIds;
};
